import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { requireUserLogin } from "../../routes/Auth";
import LeftMenu from "../../components/LeftMenu";

import MyAds from "./MyAds";
import { Context } from "../../GAContext";
import { CurrentPage } from "../../models";
import {
  clearAdControls,
  selectControls
} from "../../routes/AdForm/adForm.ducks";
import { useDispatch, useSelector } from "react-redux";
import HelmetComponent from "../../utils/HelmetHelper";
import {
  selectMyAds
} from "../../routes/Ad/ad.ducks";

const MyAdsPage = ({ match: { path } }) => {
  const location = useLocation();
  const [GaEvent, setGaEvent] = useContext(Context);
  const dispatch = useDispatch();
  const controls = useSelector(selectControls);
  const adList = useSelector(selectMyAds);


  useEffect(() => {
    if (controls) {
      dispatch(clearAdControls());
    }

    setGaEvent(CurrentPage.myAds);
    return () => {
      setGaEvent("");
    };
  }, []);
  
  return (
    <LeftMenu activeKey={path}>
      <HelmetComponent title={`${"Moji oglasi"} | ${"INDEX OGLASI"}`} index={false} />
      <MyAds />
    </LeftMenu>
  );
};


export default requireUserLogin(MyAdsPage);



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/index.tsx